/** @format */

import menuRoutes from "@model/menu-routes.js";
import registerRoutes from "@model/register-routes.js";

// 「戻る」ルートがある場合はリロード
window.addEventListener("popstate", () => {
  const url = new URL(location.href);
  if (menuRoutes.pages.find((v) => v.route.exec(url.pathname))) {
    location.reload();
  }
  if (registerRoutes.pages.find((v) => v.route.exec(url.pathname))) {
    location.reload();
  }
});
